module.exports = __webpack_public_path__ + "img/81164a3b9183a91e8cb0ac0e27899caa.png";